import React, { useRef } from 'react'
import cn from 'classnames'
import styles from '../styles.module.scss'
import { dateToTwelveHourFormat } from '../../../helpers/timeHelper'
import { messageDefinition } from '../../../helpers/support.helper'
import { getFirstName } from '../helpers'
import OutgoingControls from '../../ContextMenuControls/OutgoingControls'
import CompanionControls from '../../ContextMenuControls/CompanionControls'
import ReplyMessage from '../../ReplyMessage/ReplyMessage'

const SupportMessage = ({
  id,
  is_outgoing,
  message,
  date,
  user,
  replyMessage,
  editMessage,
  onReply,
  onEdit,
  onDelete,
  onContextMenu,
  setIsOpenMenu,
  isOpenMenu,
  onReplyClick,
  searchMessageId,
  refs,
}) => {
  const longPressTimerRef = useRef(null)
  const lastTapRef = useRef({ time: 0, x: 0, y: 0 })

  const onClick = (id) => {
    if (!id) return

    if (id === replyMessage?.id) {
      onReplyClick(id)
    }
  }

  const openMenu = (e) => {
    if (e?.preventDefault) e.preventDefault()
    if (e?.stopPropagation) e.stopPropagation()
    setIsOpenMenu(id)
  }

  const startLongPress = (e) => {
    if (longPressTimerRef.current) {
      clearTimeout(longPressTimerRef.current)
    }

    longPressTimerRef.current = setTimeout(() => {
      openMenu(e)
    }, 450)
  }

  const cancelLongPress = () => {
    if (longPressTimerRef.current) {
      clearTimeout(longPressTimerRef.current)
      longPressTimerRef.current = null
    }
  }

  const handleTouchEnd = (e) => {
    cancelLongPress()

    const now = Date.now()
    const touch = e.changedTouches?.[0]
    if (!touch) return

    const timeDiff = now - lastTapRef.current.time
    const xDiff = Math.abs(touch.clientX - lastTapRef.current.x)
    const yDiff = Math.abs(touch.clientY - lastTapRef.current.y)

    if (timeDiff < 260 && xDiff < 18 && yDiff < 18) {
      openMenu(e)
      lastTapRef.current = { time: 0, x: 0, y: 0 }
      return
    }

    lastTapRef.current = { time: now, x: touch.clientX, y: touch.clientY }
  }

  return (
    <div
      className={cn(styles.message, {
        [styles.outgoing]: is_outgoing,
      })}
    >
      <div className={styles.message_body}>
        <div
          className={cn(styles.chatName, {
            [styles.outgoing]: is_outgoing,
          })}
        >
          {getFirstName(user)}
        </div>

        <div
          ref={refs}
          className={cn(styles.message_text, { [styles.message_text__active]: searchMessageId === id })}
          onContextMenu={(e) => onContextMenu(e, id)}
          onDoubleClick={openMenu}
          onTouchStart={startLongPress}
          onTouchMove={cancelLongPress}
          onTouchCancel={cancelLongPress}
          onTouchEnd={handleTouchEnd}
          onClick={() => onClick(replyMessage?.id)}
        >
          {replyMessage && <ReplyMessage message={replyMessage} isSupport isOutgoing={is_outgoing} />}

          {messageDefinition(message, styles)}

          {is_outgoing && (
            <OutgoingControls
              id={id}
              onReply={onReply}
              onEdit={onEdit}
              onDelete={onDelete}
              setIsOpenMenu={setIsOpenMenu}
              isOpenMenu={isOpenMenu}
            />
          )}

          {!is_outgoing && (
            <CompanionControls id={id} onReply={onReply} setIsOpenMenu={setIsOpenMenu} isOpenMenu={isOpenMenu} />
          )}
        </div>

        <div className={styles.message_footer}>
          {editMessage && <span className={styles.edited}>edited</span>}

          <span className={styles.message_date}>
            <time>{dateToTwelveHourFormat(date)}</time>
          </span>
        </div>
      </div>
    </div>
  )
}

export default SupportMessage
